import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import { useGetEntityJsonConfig } from '@flowwai-frontend/bps-officer-web/common/data-access'
import { JsonConfigurationEntityType } from '@flowwai-frontend/bps-officer-web/graphql'
import {
   API_FAILED,
   API_SUCCESS,
   getLoadingStatus
} from '@flowwai-frontend/shared/api-common'
import { LoadingWrapper } from '@flowwai-frontend/shared/common-components'

interface props {
   loadingWrapperContainerCss?: React.CSSProperties
}

export const withUserSpecificAccessData = (
   Component: (_: any) => React.ReactElement
) => {
   const UserSpecificAccessDataWrapper = observer((props: props) => {
      const getEntityJsonConfigAPI = useGetEntityJsonConfig()

      const getPipelineItemTemplateAccessOverrideConfig = () => {
         getEntityJsonConfigAPI.triggerApi({
            entityType:
               JsonConfigurationEntityType.PipelineItemTemplateAccessOverrideConfig
         })
      }

      const fetchData = (): void => {
         getPipelineItemTemplateAccessOverrideConfig()
      }

      useEffect(fetchData, [])

      const apiStatus = getLoadingStatus(getEntityJsonConfigAPI.apiStatus)

      const updatedAPIStatus =
         apiStatus === API_FAILED ? API_SUCCESS : apiStatus

      return (
         <LoadingWrapper
            apiStatus={updatedAPIStatus}
            apiError={null}
            containerCss={props.loadingWrapperContainerCss}
         >
            <Component props={props} />
         </LoadingWrapper>
      )
   })

   return () => <UserSpecificAccessDataWrapper />
}
